import React, { useState } from 'react';
import { LayoutDashboardIcon, UsersIcon, BuildingIcon, ClipboardCheckIcon, ShieldCheckIcon, SettingsIcon, LogOutIcon, CheckCircleIcon, XCircleIcon, AlertCircleIcon, SearchIcon, MoreVerticalIcon, UserPlusIcon, ArrowUpIcon, ArrowDownIcon } from 'lucide-react';
// Mock data for pending verifications
const pendingVerifications = [{
  id: 1,
  name: 'Lagos Luxury Homes',
  type: 'Real Estate Agency',
  date: 'May 12, 2023',
  status: 'Pending',
  documents: 5
}, {
  id: 2,
  name: 'Johnson & Partners',
  type: 'Law Firm',
  date: 'May 11, 2023',
  status: 'Pending',
  documents: 3
}, {
  id: 3,
  name: 'Elite Interior Design',
  type: 'Service Provider',
  date: 'May 10, 2023',
  status: 'Pending',
  documents: 4
}];
// Mock data for recent transactions
const recentTransactions = [{
  id: 'TRX-39485',
  buyer: 'Oluwaseun Adeyemi',
  property: 'Luxury 3 Bedroom Apartment',
  amount: '₦75,000,000',
  date: 'May 10, 2023',
  status: 'Completed'
}, {
  id: 'TRX-39484',
  buyer: 'Chioma Okafor',
  property: 'Modern 4 Bedroom Duplex',
  amount: '₦120,000,000',
  date: 'May 8, 2023',
  status: 'In Progress'
}, {
  id: 'TRX-39483',
  buyer: 'Emeka Nwosu',
  property: 'Waterfront 5 Bedroom Villa',
  amount: '₦350,000,000',
  date: 'May 5, 2023',
  status: 'Completed'
}, {
  id: 'TRX-39482',
  buyer: 'Ngozi Eze',
  property: '2 Bedroom Apartment with Pool',
  amount: '₦65,000,000',
  date: 'May 3, 2023',
  status: 'Completed'
}, {
  id: 'TRX-39481',
  buyer: 'Tunde Bakare',
  property: '3 Bedroom Terrace House',
  amount: '₦85,000,000',
  date: 'May 1, 2023',
  status: 'In Progress'
}];
const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-846">
      <div className="flex" data-id="element-847">
        {/* Sidebar */}
        <div className="hidden md:block w-64 bg-white min-h-screen shadow-sm" data-id="element-848">
          <div className="p-6 border-b" data-id="element-849">
            <div className="flex items-center" data-id="element-850">
              <BuildingIcon className="h-8 w-8 text-[#FF4E00] mr-2" data-id="element-851" />
              <div data-id="element-852">
                <h1 className="font-bold text-xl" data-id="element-853">DiasporaHomes</h1>
                <p className="text-xs text-gray-600" data-id="element-854">Admin Panel</p>
              </div>
            </div>
          </div>
          <nav className="p-4" data-id="element-855">
            <ul className="space-y-2" data-id="element-856">
              <AdminSidebarLink icon={<LayoutDashboardIcon size={18} data-id="element-858" />} label="Dashboard" active={activeTab === 'dashboard'} onClick={() => setActiveTab('dashboard')} data-id="element-857" />
              <AdminSidebarLink icon={<UsersIcon size={18} data-id="element-860" />} label="Users" active={activeTab === 'users'} onClick={() => setActiveTab('users')} data-id="element-859" />
              <AdminSidebarLink icon={<BuildingIcon size={18} data-id="element-862" />} label="Properties" active={activeTab === 'properties'} onClick={() => setActiveTab('properties')} data-id="element-861" />
              <AdminSidebarLink icon={<ClipboardCheckIcon size={18} data-id="element-864" />} label="Transactions" active={activeTab === 'transactions'} onClick={() => setActiveTab('transactions')} data-id="element-863" />
              <AdminSidebarLink icon={<ShieldCheckIcon size={18} data-id="element-866" />} label="Verifications" active={activeTab === 'verifications'} onClick={() => setActiveTab('verifications')} badge="3" data-id="element-865" />
              <AdminSidebarLink icon={<SettingsIcon size={18} data-id="element-868" />} label="Settings" active={activeTab === 'settings'} onClick={() => setActiveTab('settings')} data-id="element-867" />
            </ul>
            <div className="mt-8 pt-4 border-t" data-id="element-869">
              <button className="flex items-center text-gray-700 hover:text-red-600 w-full px-4 py-2 rounded-lg hover:bg-red-50" data-id="element-870">
                <LogOutIcon size={18} className="mr-3" data-id="element-871" />
                <span data-id="element-872">Logout</span>
              </button>
            </div>
          </nav>
        </div>
        {/* Main Content */}
        <div className="flex-grow" data-id="element-873">
          {/* Mobile Header */}
          <div className="md:hidden bg-white p-4 shadow-sm flex justify-between items-center" data-id="element-874">
            <div className="flex items-center" data-id="element-875">
              <BuildingIcon className="h-6 w-6 text-[#FF4E00] mr-2" data-id="element-876" />
              <h1 className="font-bold" data-id="element-877">Admin</h1>
            </div>
            <button className="p-2 rounded-lg hover:bg-gray-100" data-id="element-878">
              <MoreVerticalIcon size={20} data-id="element-879" />
            </button>
          </div>
          <div className="p-6" data-id="element-880">
            <div className="flex justify-between items-center mb-6" data-id="element-881">
              <h1 className="text-2xl font-bold" data-id="element-882">Admin Dashboard</h1>
              <div className="flex items-center" data-id="element-883">
                <span className="text-gray-600 mr-2" data-id="element-884">Welcome, Admin</span>
                <div className="w-10 h-10 bg-[#FFF1EC] rounded-full flex items-center justify-center" data-id="element-885">
                  <UsersIcon size={20} className="text-[#FF4E00]" data-id="element-886" />
                </div>
              </div>
            </div>
            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-887">
              <StatCard title="Total Users" value="1,245" change="+12%" positive={true} data-id="element-888" />
              <StatCard title="Properties Listed" value="328" change="+8%" positive={true} data-id="element-889" />
              <StatCard title="Transactions" value="₦1.2B" change="+23%" positive={true} data-id="element-890" />
              <StatCard title="Pending Verifications" value="3" change="-2" positive={false} data-id="element-891" />
            </div>
            {/* Pending Verifications */}
            <div className="bg-white rounded-lg shadow-sm p-6 mb-8" data-id="element-892">
              <div className="flex justify-between items-center mb-6" data-id="element-893">
                <h2 className="text-lg font-bold" data-id="element-894">Pending Verifications</h2>
                <button className="text-[#FF4E00] hover:underline text-sm" data-id="element-895">
                  View All
                </button>
              </div>
              <div className="overflow-x-auto" data-id="element-896">
                <table className="w-full" data-id="element-897">
                  <thead data-id="element-898">
                    <tr className="text-left text-gray-600 text-sm border-b" data-id="element-899">
                      <th className="pb-3 pl-4" data-id="element-900">Name</th>
                      <th className="pb-3" data-id="element-901">Type</th>
                      <th className="pb-3" data-id="element-902">Date</th>
                      <th className="pb-3" data-id="element-903">Documents</th>
                      <th className="pb-3" data-id="element-904">Status</th>
                      <th className="pb-3" data-id="element-905">Action</th>
                    </tr>
                  </thead>
                  <tbody data-id="element-906">
                    {pendingVerifications.map(item => <tr key={item.id} className="border-b hover:bg-gray-50" data-id="element-907">
                        <td className="py-3 pl-4" data-id="element-908">{item.name}</td>
                        <td className="py-3" data-id="element-909">{item.type}</td>
                        <td className="py-3" data-id="element-910">{item.date}</td>
                        <td className="py-3" data-id="element-911">{item.documents} files</td>
                        <td className="py-3" data-id="element-912">
                          <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full" data-id="element-913">
                            {item.status}
                          </span>
                        </td>
                        <td className="py-3" data-id="element-914">
                          <div className="flex space-x-2" data-id="element-915">
                            <button className="p-1 text-[#FF4E00] hover:bg-[#FFF1EC] rounded" data-id="element-916">
                              <CheckCircleIcon size={18} data-id="element-917" />
                            </button>
                            <button className="p-1 text-red-600 hover:bg-red-50 rounded" data-id="element-918">
                              <XCircleIcon size={18} data-id="element-919" />
                            </button>
                            <button className="p-1 text-blue-600 hover:bg-blue-50 rounded" data-id="element-920">
                              <AlertCircleIcon size={18} data-id="element-921" />
                            </button>
                          </div>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
            {/* Recent Transactions */}
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-922">
              <div className="flex justify-between items-center mb-6" data-id="element-923">
                <h2 className="text-lg font-bold" data-id="element-924">Recent Transactions</h2>
                <div className="flex space-x-2" data-id="element-925">
                  <div className="relative" data-id="element-926">
                    <input type="text" placeholder="Search..." className="pl-8 pr-4 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-927" />
                    <SearchIcon size={14} className="absolute left-2.5 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-928" />
                  </div>
                  <button className="text-[#FF4E00] hover:underline text-sm" data-id="element-929">
                    View All
                  </button>
                </div>
              </div>
              <div className="overflow-x-auto" data-id="element-930">
                <table className="w-full" data-id="element-931">
                  <thead data-id="element-932">
                    <tr className="text-left text-gray-600 text-sm border-b" data-id="element-933">
                      <th className="pb-3 pl-4" data-id="element-934">ID</th>
                      <th className="pb-3" data-id="element-935">Buyer</th>
                      <th className="pb-3" data-id="element-936">Property</th>
                      <th className="pb-3" data-id="element-937">Amount</th>
                      <th className="pb-3" data-id="element-938">Date</th>
                      <th className="pb-3" data-id="element-939">Status</th>
                      <th className="pb-3" data-id="element-940">Action</th>
                    </tr>
                  </thead>
                  <tbody data-id="element-941">
                    {recentTransactions.map(transaction => <tr key={transaction.id} className="border-b hover:bg-gray-50" data-id="element-942">
                        <td className="py-3 pl-4 font-medium" data-id="element-943">
                          {transaction.id}
                        </td>
                        <td className="py-3" data-id="element-944">{transaction.buyer}</td>
                        <td className="py-3" data-id="element-945">{transaction.property}</td>
                        <td className="py-3 font-medium" data-id="element-946">
                          {transaction.amount}
                        </td>
                        <td className="py-3" data-id="element-947">{transaction.date}</td>
                        <td className="py-3" data-id="element-948">
                          <span className={`px-2 py-1 text-xs rounded-full ${transaction.status === 'Completed' ? 'bg-[#FFF1EC] text-[#FF4E00]' : 'bg-blue-100 text-blue-800'}`} data-id="element-949">
                            {transaction.status}
                          </span>
                        </td>
                        <td className="py-3" data-id="element-950">
                          <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50 text-sm" data-id="element-951">
                            Details
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
              <div className="mt-4 flex justify-between items-center text-sm text-gray-600" data-id="element-952">
                <div data-id="element-953">Showing 1 to 5 of 24 entries</div>
                <div className="flex space-x-1" data-id="element-954">
                  <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" data-id="element-955">
                    Previous
                  </button>
                  <button className="px-3 py-1 bg-[#FF4E00] text-white rounded" data-id="element-956">
                    1
                  </button>
                  <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" data-id="element-957">
                    2
                  </button>
                  <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" data-id="element-958">
                    3
                  </button>
                  <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" data-id="element-959">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
interface AdminSidebarLinkProps {
  icon: React.ReactNode;
  label: string;
  active: boolean;
  onClick: () => void;
  badge?: string;
}
const AdminSidebarLink: React.FC<AdminSidebarLinkProps> = ({
  icon,
  label,
  active,
  onClick,
  badge
}) => <li data-id="element-960">
    <button className={`flex items-center justify-between w-full px-4 py-2 rounded-lg ${active ? 'bg-[#FFF1EC] text-[#FF4E00]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={onClick} data-id="element-961">
      <div className="flex items-center" data-id="element-962">
        <span className="mr-3" data-id="element-963">{icon}</span>
        <span data-id="element-964">{label}</span>
      </div>
      {badge && <span className="bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-965">
          {badge}
        </span>}
    </button>
  </li>;
interface StatCardProps {
  title: string;
  value: string;
  change: string;
  positive: boolean;
}
const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  change,
  positive
}) => <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-966">
    <div className="flex justify-between items-start mb-4" data-id="element-967">
      <h3 className="text-gray-600 font-medium" data-id="element-968">{title}</h3>
    </div>
    <div className="flex items-end justify-between" data-id="element-969">
      <p className="text-2xl font-bold" data-id="element-970">{value}</p>
      <div className={`flex items-center text-sm ${positive ? 'text-[#FF4E00]' : 'text-red-600'}`} data-id="element-971">
        {positive ? <ArrowUpIcon size={16} className="mr-1" data-id="element-972" /> : <ArrowDownIcon size={16} className="mr-1" data-id="element-973" />}
        <span data-id="element-974">{change}</span>
      </div>
    </div>
  </div>;
export default AdminPanel;